import React from 'react';

const ShowList = (props)=>{
    
    const onCloseClick = (item)=>{
        const newList = props.items.filter((ele)=>{
            return ele !== item
        })
        props.setItems(newList);
    }

    const strikeThru = (e)=>{
        const style = "text-decoration"
        const value = "line-through"
        const exists = Object.keys(e.target.style).some((k)=> {
            return e.target.style[k] === value;
        });
        if(exists){
            e.target.style[style] = "";
        }
        else{
            e.target.style["text-decoration"] = "line-through"
        }
    }

    const pointer = {
        cursor: 'pointer'
    }

    return(
        <div className = "react-list-items-table-container">
             <table className = "react-list-items-table">
                 <tbody className = "react-list-items-tbody">
                {props.items.map((ele,index)=>{
                    return (
                    <tr key={index} className = "react-list-items-row">
                        <td onClick={strikeThru} className="react-list-items-td-item" key={index}>{ele}</td>
                        <td style={pointer} className="react-list-items-td-x" onClick={()=>{onCloseClick(ele)}}>X</td>
                    </tr>
                    )
            })}
                </tbody>
            </table>
        </div>
    )
}

export default ShowList;
